export default __webpack_public_path__ + "static/media/supersetlogo.c9710ed6.png";